import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import AddressBtn from "../../components/addressBtn/addressBtn.component";
// import AddressBtn from "../../components/addressBtn/addressBtn.component";
import {
  selectNewRequestDestLocation,
  selectNewRequestSourceLocation,
} from "../../redux/newRequest/newRequest.selectors";
import CarSelection from "../carSelection/carSelection.component";
import SubmitReqRightColBtns from "../submitReqRightColBtns/submitReqRightColBtns.component";
import SuggestionBox from "../suggestionBox/suggestionBox.componentj";

const SubmitReqRightCol = ({
  newRequestSourceLocation,
  newRequestDestLocation,
}) => {
  console.log(newRequestDestLocation);
  //   debugger;
  return (
    <div>
      <div>
        <AddressBtn
          color="#3278d7"
          title={newRequestSourceLocation.shahr_name}
          content={newRequestSourceLocation.ostan_name}
          className="mb-3"
        />
        <AddressBtn
          color="#48cfad"
          title={newRequestDestLocation.shahr_name}
          content={newRequestDestLocation.ostan_name}
        />
      </div>

      <CarSelection />

      <div className="mt-4">
        <SuggestionBox />
      </div>

      <div>
        <SubmitReqRightColBtns />
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  newRequestSourceLocation: selectNewRequestSourceLocation,
  newRequestDestLocation: selectNewRequestDestLocation,
});

export default connect(mapStateToProps)(SubmitReqRightCol);
